import type React from 'react';

export interface BvIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const BvIcon: React.FC<BvIconProps> = ({
	width = 15,
	height = 15,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Benefits Verification Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 15 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.16456 0.832655C0.838861 0.832655 0.573866 1.09905 0.573866 1.42652V13.5765C0.573866 13.9022 0.838861 14.1673 1.16456 14.1673L13.8446 14.1673C14.1703 14.1673 14.4353 13.9022 14.4353 13.5765V1.42327C14.4353 1.0976 14.1703 0.832637 13.8446 0.832637L1.16456 0.832655ZM13.8446 14.5H1.16456C0.655434 14.5 0.241211 14.0856 0.241211 13.5765V1.4265C0.241211 0.915623 0.655434 0.500019 1.16456 0.500019L13.8446 0.5C14.3537 0.5 14.7679 0.914214 14.7679 1.42333V13.5766C14.7679 14.0856 14.3537 14.5 13.8446 14.5Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.6016 3.06581H0.407539C0.315676 3.06581 0.241211 2.99136 0.241211 2.89951C0.241211 2.80766 0.315676 2.73318 0.407539 2.73318L14.6016 2.73315C14.6934 2.73315 14.7679 2.80766 14.7679 2.89951C14.7679 2.99135 14.6934 3.06584 14.6016 3.06581Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.74511 1.94935H1.47395C1.3821 1.94935 1.30762 1.87488 1.30762 1.78303C1.30762 1.69115 1.38209 1.6167 1.47395 1.6167H2.74511C2.83696 1.6167 2.91144 1.69117 2.91144 1.78303C2.91144 1.87486 2.83696 1.94935 2.74511 1.94935Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.70016 1.94935H3.42902C3.33717 1.94935 3.2627 1.87488 3.2627 1.78303C3.2627 1.69115 3.33716 1.6167 3.42902 1.6167H4.70016C4.79201 1.6167 4.86652 1.69117 4.86652 1.78303C4.86652 1.87486 4.79201 1.94935 4.70016 1.94935Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.65624 1.94935H5.38508C5.29322 1.94935 5.21875 1.87488 5.21875 1.78303C5.21875 1.69115 5.29322 1.6167 5.38508 1.6167H6.65624C6.7481 1.6167 6.82256 1.69117 6.82256 1.78303C6.82257 1.87486 6.7481 1.94935 6.65624 1.94935Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.20767 5.24697H12.8044V4.06874H2.20767V5.24697ZM12.9707 5.57963H2.04135C1.94948 5.57963 1.875 5.50517 1.875 5.41329L1.87501 3.90245C1.87501 3.81054 1.94948 3.73609 2.04135 3.73609L12.9707 3.73608C13.0626 3.73608 13.137 3.81057 13.137 3.90245L13.1371 5.41326C13.1371 5.50517 13.0626 5.57963 12.9707 5.57963Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.20767 7.8871H12.8044V6.70888H2.20767V7.8871ZM12.9707 8.21975H2.04135C1.94948 8.21975 1.875 8.1453 1.875 8.05342L1.87501 6.54255C1.87501 6.4507 1.94948 6.37624 2.04135 6.37624L12.9707 6.37622C13.0626 6.37622 13.137 6.4507 13.137 6.54257L13.1371 8.05342C13.1371 8.14527 13.0626 8.21975 12.9707 8.21975Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.20767 10.5272H12.8044V9.34901H2.20767V10.5272ZM12.9707 10.8599H2.04135C1.94948 10.8599 1.875 10.7854 1.875 10.6936L1.87501 9.18268C1.87501 9.09081 1.94948 9.01636 2.04135 9.01636H12.9707C13.0626 9.01636 13.137 9.09083 13.137 9.18268L13.1371 10.6935C13.1371 10.7854 13.0626 10.8599 12.9707 10.8599Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.05348 11.9892C4.91478 11.9892 4.7849 12.0432 4.68778 12.1411C4.59241 12.2372 4.54052 12.3646 4.54164 12.4997L4.54167 12.6525C4.54167 12.9346 4.77126 13.1642 5.05348 13.1642L9.95829 13.1642C10.2405 13.1642 10.4701 12.9346 10.4701 12.6525V12.5009C10.4701 12.2187 10.2405 11.9892 9.95829 11.9892L5.05348 11.9892ZM5.05348 13.4968C4.58785 13.4968 4.20902 13.118 4.20902 12.6525V12.5009C4.20711 12.2779 4.29328 12.0666 4.45154 11.9069C4.61165 11.7454 4.82542 11.6565 5.05348 11.6565L9.95829 11.6565C10.4239 11.6565 10.8028 12.0354 10.8028 12.5009V12.6525C10.8028 13.1179 10.4239 13.4968 9.95829 13.4968L5.05348 13.4968Z"
			fill="currentColor"
		/>
	</svg>
);

export default BvIcon;
